// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__3oSR5","list":"BalanceDue_list__3xEaa","listRow":"BalanceDue_listRow__15xdm","total":"BalanceDue_total__3_nhg"};